// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__vBEP5","layout__hidden":"layout_layout__hidden__o_FUf"};